var map = {
	"./$GMUSIC-icon.png": 1013,
	"./BAT-icon.png": 1014,
	"./BTC-icon.png": 1015,
	"./BXC-icon.png": 1016,
	"./CC-icon.png": 507,
	"./DistTest-icon.png": 1375,
	"./ETH-icon.png": 1017,
	"./GALA-icon.png": 664,
	"./GALA[ETH]-icon.png": 1376,
	"./GALA[GYRI]-icon.png": 1377,
	"./MTRM-icon.png": 1378,
	"./MTRM[ETH]-icon.png": 1379,
	"./MTRM[GYRI]-icon.png": 1380,
	"./NODETESTCOIN-icon.png": 1381,
	"./NODETESTCOIN-transparent-icon.png": 1382,
	"./SILK-icon.png": 1018,
	"./SILK[GYRI]-icon.png": 1383,
	"./TANK-icon.png": 1019,
	"./TCTESTCOIN-icon.png": 1384,
	"./TEST-icon.png": 1385,
	"./TOWN-icon.png": 1020,
	"./USD-icon.png": 759,
	"./mastercard-icon.png": 505,
	"./simplex-icon.png": 1021,
	"./visa-icon.png": 506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 657;